import type { ReactNode } from 'react';

export interface FieldProps {
  label?: string;
  hint?: string;
  error?: string;
  children: ReactNode;
}

/**
 * Field — label + hint + error wrapper.
 *
 * Composes around any input control (TextInput, DropdownSelect, Toggle, ...)
 * to provide consistent label typography + error/hint affordances across
 * forms. Error supersedes hint when both are present.
 */
export function Field({ label, hint, error, children }: FieldProps) {
  return (
    <label className="block">
      {label && (
        <span className="block text-[11.5px] font-semibold text-ms-text-strong mb-1">
          {label}
        </span>
      )}
      {children}
      {error ? (
        <span className="block text-[11px] text-rose-600 mt-1">{error}</span>
      ) : hint ? (
        <span className="block text-[11px] text-ms-text-muted mt-1">{hint}</span>
      ) : null}
    </label>
  );
}
